import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function restoreFile(functionClient, fileEntityType, onSuccess, fileId, parentId) {
    functionClient
        .executeFunction({ functionName: 'restoreFile', params: { fileId, parentId } })
        .then(() => {
        showAlertSnackbar({
            horizontalPosition: 'center',
            type: 'success',
            verticalPosition: 'bottom',
            autoHideDuration: 2000,
            message: `${fileEntityType} restored.`,
        });
        onSuccess();
    })
        .catch(handleErrorDialog);
}
